module.exports = __webpack_public_path__ + "static/media/Avatars_Other-04.048e485e.png";